<template>
	<v-layout class="financial-table-header-font-size" style="page-break-inside: avoid">
		<v-flex d-flex xs1>
			<v-card tile color='grey darken-1' class="financial-table-header-color">
				<v-card-text style="text-align: center">
					<strong>
						Rodzaj kosztu
					</strong>
				</v-card-text>
			</v-card>
		</v-flex>
		<v-flex d-flex xs5>
			<v-card tile color='grey darken-1' class="financial-table-header-color">
				<v-card-text style="text-align: center">
					<strong>
						Koszty zgodnie z umową (w zł)
					</strong>
				</v-card-text>
			</v-card>
		</v-flex>
		<v-flex d-flex xs6>
			<v-card tile color='grey darken-1' class="financial-table-header-color">
				<v-card-text style="text-align: center">
					<strong>
						Faktycznie poniesione wydatki (w zł)
					</strong>
				</v-card-text>
			</v-card>
		</v-flex>
	</v-layout>
</template>
<script>
	export default {
		name: 'financial-table-types-top-header'
	};
</script>